import { render, staticRenderFns } from "./DateItem.vue?vue&type=template&id=98c74fc2&scoped=true&"
import script from "./DateItem.vue?vue&type=script&lang=js&"
export * from "./DateItem.vue?vue&type=script&lang=js&"
import style0 from "./DateItem.vue?vue&type=style&index=0&id=98c74fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c74fc2",
  null
  
)

export default component.exports